import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import Datafeed from './api/';

class BinanceView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const cookies = new Cookies();
    let fSym = cookies.get('fSym') || 'BTCUSDT';
    let fRes = cookies.get('fRes') || 60;

    window.tvWidget = new TradingView.widget({
      symbol: fSym,
      interval: fRes,
      fullscreen: true,
      container_id: 'tv_chart_container',
      datafeed: new Datafeed(),
      library_path: '/charting_library/',
    });
  }

  render() {
    return <div id="tv_chart_container"></div>;
  }
}
export default BinanceView;
